import { useKeycloak } from '@react-keycloak/web'
import { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { fetchProfileAction } from '../../store/slices/profile/actions'
import { useAppDispatch } from '../../store/hooks'
import { Loader } from '../../components/Loader'

const ProtectedGateway = (): JSX.Element => {
  const { keycloak } = useKeycloak()
  const dispatch = useAppDispatch()
  if (!keycloak.authenticated) {
    window.location.href = keycloak.createLoginUrl()
  }

  useEffect(() => {
    if (keycloak.authenticated) {
      dispatch(fetchProfileAction())
    }
  }, [keycloak.authenticated, dispatch])

  return keycloak.authenticated ? <Outlet /> : <Loader />
}

export default ProtectedGateway
